/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 08/05/18
 */

export const PAYMENT_METHOD_KEY = {
  OVO: 'ovo',
  GOPAY: 'gopay',
  DANA: 'dana',
  TCASH: 'tcash',
  AKULAKU: 'akulaku',
  KREDIVO: 'kredivo',
  ALIPAY: 'alipay',
  WECHATPAY: 'wechatpay',
};

export const EWALLET_TYPE = [
  PAYMENT_METHOD_KEY.OVO,
  PAYMENT_METHOD_KEY.GOPAY,
  PAYMENT_METHOD_KEY.DANA,
  PAYMENT_METHOD_KEY.TCASH,
  PAYMENT_METHOD_KEY.AKULAKU,
  PAYMENT_METHOD_KEY.KREDIVO,
  PAYMENT_METHOD_KEY.ALIPAY,
  PAYMENT_METHOD_KEY.WECHATPAY,
];

export const LIST_EWALLET_REQUIRED_KTP_NAME = [
  PAYMENT_METHOD_KEY.AKULAKU,
  PAYMENT_METHOD_KEY.KREDIVO,
  PAYMENT_METHOD_KEY.DANA,
];

export const PAYMENT_METHOD_LABEL_SHIFT = {
  EDC: 'EDC',
  BCA: 'BCA',
  MANDIRI: 'Mandiri',
  BRI: 'BRI',
  BNI: 'BNI',
  CIMB_NIAGA: 'CIMB Niaga',
  OTHER_EDC: 'Other EDC',
  EDC_REFUNDS: 'EDC Refunds',
  EDC_EXPECTED_PAYMENT: 'Expected EDC Payment',
  GIFT_CARD: 'Gift Card',
  GO_PAY: 'GO-PAY',
  OTHER: 'Other',
  OTHER_REFUNDS: 'Other Refunds',
  EXPECTED_OTHER_PAYMENT: 'Expected Other Payment',
  OVO: 'OVO',
  GOPAY: 'GO-PAY',
  DANA: 'DANA',
  TCASH: 'T-Cash',
  AKULAKU: 'Akulaku',
  KREDIVO: 'Kredivo',
  ALIPAY: 'Alipay',
  WECHATPAY: 'WeChat Pay',
  EXPECTED_EWALLET_PAYMENT: 'Expected E-Wallet Payment',
  GRABFOOD: 'Grabfood',
  ONLINE_ORDERS: 'Online Orders',
  GOFOOD: 'GoFood',
};

export const PAYMENT_METHOD_CATEGORY = {
  CASH: 'cash',
  INVOICE: 'invoice',
  INTEGRATION: 'integration',
  CARD: 'card',
  E_WALLET: 'e-wallet',
  EDC: 'edc',
  OTHER: 'other',
};

export const PAYMENT_METHOD_CATEGORY_REFUND_LABEL = {
  [PAYMENT_METHOD_CATEGORY.CARD]: 'Voided',
};
